import httpInstance from "../httpInstance";

export const putResources = async (jwtToken: string, id: any, data: any) => {
    let res: any;
    const endpoint = `resource/${id}/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`,
        }
    };

    await httpInstance.post(endpoint, data, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const reactivateResource = async (jwtToken: string, id: any) => {
    let res: any;
    const endpoint = `restoreResource/${id}/`;

    const config = {
        headers: {
            Authorization: `${localStorage.getItem('jwt')}`,
        }
    };

    await httpInstance.put(endpoint, {}, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}